import { useStore } from '@/providers/app-store-provider';
import { isInZeloolApp, isMobileScreenFunc } from '@/utils/tools';
import { useEffect, useRef } from 'react';

export const useEventListenInit = () => {
  const scrollIconTimer = useRef<NodeJS.Timeout | null>(null);
  const isMobileScreenRef = useRef<boolean>(false);
  const setIsShowAppDownloadBanner = useStore((state) => state.setIsShowAppDownloadBanner);
  const setIsShowDtBanner = useStore((state) => state.setIsShowDtBanner);
  const setIsShowScrollToTop = useStore((state) => state.setIsShowScrollToTop);
  const setIsHalfStickyRightBottomIcons = useStore(
    (state) => state.setIsHalfStickyRightBottomIcons,
  );
  const setIsMobileScreen = useStore((state) => state.setIsMobileScreen);

  useEffect(() => {
    // 判断是否为移动端（以680px为分界点）
    const isMobileSc = isMobileScreenFunc();

    // 全局存储
    isMobileScreenRef.current = isMobileSc;
    setIsMobileScreen(isMobileSc);

    const handleScroll = () => {
      const { scrollTop } = document.querySelector('html');
      // 处理顶通和APP下载的隐藏和显示
      // APP下载Banner只会在首页展示，其他页面不展示
      // 这里其实是靠配置的，目前只在首页展示，这样写也还行，后续如果扩展，还是需要改掉！！
      if (location.pathname === '/') {
        if (scrollTop === 0) {
          setIsShowAppDownloadBanner(true);
        }
        if (scrollTop >= 125) {
          setIsShowAppDownloadBanner(false);
        }
      } else {
        setIsShowAppDownloadBanner(false);
      }
      if (location.pathname === '/') {
        if (scrollTop === 0) {
          setIsShowDtBanner(true);
        }
        if (scrollTop >= 125) {
          setIsShowDtBanner(false);
        }
        // TODO: 这里还有待做的，就是前页面已经隐藏了，那么下一个页面还是隐藏，除非用户滚动起来！
      } else if (scrollTop === 0) {
        setIsShowDtBanner(true);
      } else {
        setIsShowDtBanner(false);
      }
      // 处理侧标的右下角的图标的展示和半隐藏
      // 这里的53是一个大致的高度，顶部header高度为53，其他带有顶部的页面与之大致相同
      const onePageHeight = window.innerHeight - 53;
      if (scrollTop > onePageHeight) {
        setIsShowScrollToTop(true);
      } else {
        setIsShowScrollToTop(false);
      }
      setIsHalfStickyRightBottomIcons(true);
      if (scrollIconTimer.current) {
        clearTimeout(scrollIconTimer.current);
      }
      scrollIconTimer.current = setTimeout(() => {
        setIsHalfStickyRightBottomIcons(false);
      }, 2000);
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.key === 'zl-token') {
        window.location.reload();
      }
    };

    // 监听窗口尺寸变化
    const handleResize = () => {
      const isMobileS = window.innerWidth < 680;

      // 如果设备类型发生变化，刷新页面
      if (isMobileScreenRef.current !== isMobileS) {
        // 使用window.location.reload()刷新页面
        window.location.reload();
        setIsMobileScreen(isMobileS);
        isMobileScreenRef.current = isMobileS;
      }
    };

    // 添加事件监听器
    window.addEventListener('scroll', handleScroll, { passive: false });
    window.addEventListener('resize', handleResize);

    if (!isInZeloolApp()) {
      // 另一个tab页登录状态发生变化，刷新页面
      window.addEventListener('storage', handleStorage);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);
};
